/**
 * Handles swatch element selection and UI updates
 */
function initializeSwatchHandlers() {
    $(".swatch-element").click(function() {
      $(".addtoca").removeClass("unavailable");
      $(this).parent().children(".swatch-element").removeClass("selected-swatch");
      $(this).addClass("selected-swatch");
      $(".variants-available").addClass("selected");
    });
  }
  
  /**
   * Initializes pre-order button functionality
   */
  function initializePreOrderButton() {
    $('.pre-order-container').on('click', function() {
      var href = $('.pre-order').attr("href");
      window.open(href, '_blank');
    });
  }
  
  /**
   * Handles dropdown interactions
   */
  function initializeDropdowns() {
    $(".dropdown-title").click(function() {
      $(this).find("span").toggle();
      $(this).closest('.product-dropdown').find(".dropdown-content").toggle();
    });
  }
  
  /**
   * Initializes product add button behavior
   */
  function initializeAddButton() {
    $('#product-add').on('click', function() {
      if (!$(this).hasClass('selected')) {
        $('#variants-container').addClass('black');
      }
    });
  }
  
  /**
   * Initializes product imagery slider
   */
  function initializeProductSlider() {
    const myCustomSlider = document.querySelectorAll('#product-imagery');
    
    for (let i = 0; i < myCustomSlider.length; i++) {
      const slider = myCustomSlider[i];
      const slides = slider.querySelectorAll('.swiper-slide');
      
      if (slides.length > 1) {
        slider.classList.add('swiper-' + i);
        new Swiper('.swiper-' + i, {
          direction: 'horizontal',
          loop: true,
          slidesPerView: 1,
          navigation: {
            nextEl: '.swiper-button-next-pdp',
            prevEl: '.swiper-button-prev-pdp',
          }
        });
      } else {
        slider.classList.add('single-slide');
      }
    }
  }
  
  // Initialize independent functionality when DOM is ready
  $(document).ready(function() {
    initializeSwatchHandlers();
    initializePreOrderButton();
    initializeDropdowns();
    initializeAddButton();
  });
  
  // Initialize slider when all assets are loaded
  $(window).on("load", initializeProductSlider);